import { NgForOf } from "@angular/common";
import { Directive, Host, Input, type NgIterable } from "@angular/core";

@Directive({
    // tslint:disable-next-line: directive-selector
    selector: '[ngForTrackById]',
    standalone: false
})
export class NgForTrackByIdDirective<T extends {id: number | string}> {

    @Input() ngForOf!: NgIterable<T>;

    constructor(@Host() ngForOfDir: NgForOf<T>) {
        ngForOfDir.ngForTrackBy = (_, item: T) => item.id;
    }
}